const loadAsyncBackgroundImage = (element, imgUrl) => {
  // in order to get the "load" event to fire for a background
  // need to create an Image instance, 
  // and on it's load event, set the backgroundImage
  const image = new Image();
  image.src = imgUrl;
  image.addEventListener('load', function() {
      this.remove();
      element.classList.add('loaded');
      if (element.classList.contains('linear-gradient')) {
          // NOTE linear-gradient value here equal to $faded-blue
          // Prefer to use :after here, but can use this as a fallback
          element.style.backgroundImage = `linear-gradient(rgba(41, 59, 91, 0.5), rgba(41, 59, 91, 0.5)), url(${imgUrl})`;
      } else {
          element.style.backgroundImage = `url(${imgUrl})`;
      }
  });
}

// Load images inside the section DOM element
// with class 'async-images'
// Load image and set background-image: url()
// for elements with async-img-background
// Called when section comes into viewport
const loadAsyncImages = (section) => {
  const images = section.querySelectorAll('img.async-img');
  const backgroundImages = section.querySelectorAll('.async-img-background');

  for (let i = 0; i < images.length; i++) {
      images[i].src = images[i].dataset.src;
      images[i].addEventListener('load', () => {
          images[i].classList.add('loaded');
      });
  }

  // Same as above except it sets the background-image of an element
  for (let i = 0; i < backgroundImages.length; i++) {
      const backgroundImg = backgroundImages[i];
      const imgUrl = backgroundImg.dataset.src;
      loadAsyncBackgroundImage(backgroundImg, imgUrl);
  }

  // if section itself has a background to be loaded asynchronously
  if (section.classList.contains('async-img-background')) {
      loadAsyncBackgroundImage(section, section.dataset.src);
  }
}


export {
  loadAsyncBackgroundImage,
  loadAsyncImages
}
